import React, { useEffect } from 'react';
import { Metadata } from '@thd-olt-component-react/metadata';
import { GiftCardsCheckBalanceAndReload } from '@thd-olt-component-react/gift-cards-check-balance-and-reload';
import { GiftCardMaintenanceAlert, useDisabledGiftCardFlow } from '@thd-olt-component-react/gift-cards-information';
import Breadcrumbs from '../components/breadcrumbs/Breadcrumbs';
import { FEATURE_SWITCH_NAMES, staticPageUrls } from '../utils/consts';
import useAuth from '../hooks/useAuth';
import { getJWT } from '../utils/utils';
import '../styles/app.scss';

export const Balance = () => {
  const { isFlowDisabled } = useDisabledGiftCardFlow(FEATURE_SWITCH_NAMES.DISABLE_GIFT_CARD_CHECK_BALANCE_AND_RELOAD);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('giftcards.check-balance');
  });

  const metaData = {
    alternateUrlEn: 'https://www.homedepot.com/gift-cards/balance',
    siteName: 'The Home Depot',
    title: 'Check Balance and Reload - The Home Depot',
    type: 'Content',
  }

  const { data, loading, goToAuth } = useAuth();
  const jwt = getJWT();

  useEffect(() => {
    if (!jwt && !isFlowDisabled) {
      goToAuth();
    }
  }, [])

  useEffect(() => {
    if (loading) return;
    if (!data?.validateSession && !isFlowDisabled) {
      goToAuth();
    }
  }, [loading, data?.validateSession])

  return (
    // eslint-disable-next-line max-len
    <div className="sui-mb-6 sm:sui-mt-6 sui-max-w-screen-2xl sui-p-4 sui-mx-auto sui-bg-primary">
      <Metadata data={metaData} />
      <div className="md:max-w-3xl sui-grid sui-grid-cols-1">
        <Breadcrumbs
          startFromHome
          breadcrumbs={[
            staticPageUrls.landing,
            staticPageUrls.balanceReload
          ]}
        />
        {isFlowDisabled ? <GiftCardMaintenanceAlert /> : (
          <GiftCardsCheckBalanceAndReload />
        )}
      </div>
    </div>
  );
};

Balance.displayName = 'GiftCardBalancePage';
